import { render } from "./favorite.vue?vue&type=template&id=ec4fd3da&scoped=true"
import script from "./favorite.vue?vue&type=script&lang=js"
export * from "./favorite.vue?vue&type=script&lang=js"

import "./favorite.vue?vue&type=style&index=0&id=ec4fd3da&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec4fd3da"]])

export default __exports__